module.exports = __webpack_public_path__ + "img/cilinder.232e9578.png";